export default __webpack_public_path__ + "static/media/pp-img.66f20bb8.webp";